import {
  planStatus,
} from "@/lib/utils";
import { useGetNoteList } from "@/services";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { useMemo, useState } from "react";

const useNotes = () => {
  const {id} = useParams();
  const [activeTab, setActiveTab] = useState<string>("pm");

  const {taskData, planData} = useSelector((state: RootState) => state.currentData)

  const {data: noteList, isLoading: isLoadingNote} = useGetNoteList({
    taskId: taskData?.taskId,
    projectId: id as string
  });

  const isPlanApproved = useMemo(() => planData?.status == planStatus.approved.value, [planData]);

  const onChangeTab = (currentTab: string) => {
    setActiveTab(currentTab)
  }

  const noteListByRole = useMemo(() => {
    if (activeTab == "pm") {
      return noteList?.data?.filter((data: any) => data?.createdByRoleName?.toLowerCase() == "project manager")
    } else if (activeTab == "sm") {
      return noteList?.data?.filter((data: any) => data?.createdByRoleName?.toLowerCase() == "site manager")
    } else if (activeTab == "qc") {
      return noteList?.data?.filter((data: any) => data?.createdByRoleName?.toLowerCase() == "quality officer")
    } else if (activeTab == "sc") {
      return noteList?.data?.filter((data: any) => data?.createdByRoleName?.toLowerCase() == "safety officer")
    }
    return [];
  }, [activeTab, noteList]);

  return {
    isLoadingNote,
    activeTab,
    onChangeTab,
    noteListByRole: noteListByRole || [],
    isPlanApproved
  };
};

export default useNotes;
